/**
 * 檔案用途區塊
 * @module format.helper
 * @purpose 提供路徑字串正規化工具，統一路由使用的絕對、相對與去除查詢參數格式。
 * @external https://innotech.atlassian.net/browse/IN-40532
 */

/**
 * 宣告內容用途說明與單號關聯
 * @description 移除路徑開頭的斜線，將絕對型式轉為不含前導斜線的型式。
 * @purpose 用於需要以純路徑片段進行比對或串接時，避免前導斜線造成格式不一致。
 * @external https://innotech.atlassian.net/browse/IN-40532
 */
export const formatAbsolutePathname = (pathname: string) => {
  if (pathname && pathname[0] === '/') {
    return pathname.slice(1);
  }
  return pathname;
};

/**
 * 宣告內容用途說明與單號關聯
 * @description 檢查路徑是否已有前導斜線，若無則補上以形成相對路徑表示。
 * @purpose 確保輸入可被統一視為以斜線起始的路徑格式，降低路由組裝差異。
 */
export const formatRelativePathname = (pathname: string) => (/^\//.test(pathname) ? pathname : `/${pathname}`);

/**
 * 宣告內容用途說明與單號關聯
 * @description 去除 URL 查詢參數，並將首字元大寫路徑轉為小寫開頭。
 * @purpose 讓路徑在後續比對、轉址或權限判斷時維持一致的主路徑格式。
 * @external https://innotech.atlassian.net/browse/IN-40532
 */
export const formatPurePathname = (pathname: string) =>
  pathname.replace(/\?[\w|\W]+/, '').replace(/^[A-Z]/, pathname[0]?.toLowerCase());

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:24:30.876Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note 已僅調整註解並保留原始執行邏輯：新增頂部「檔案用途區塊」、每個宣告的「宣告內容用途說明與單號關聯」、底部「llm 分析紀錄區」。@external 僅套用於有 ticket 的宣告與檔案層級，且使用完整 Jira URL。
 */
